import containerFuild from '../html-snippets/container-fuild.js';
import css from '../css-snippets/fastvaluedeal-money-back-guarantee';

const html = `
<div
  class="fvd-mbg-content container"
  data-attribute="fvd-mbg-content"
  data-image-position="left"
>
  <div class="fvd-mbg__image" data-attribute="fvd-mbg__image">
    <img
      data-attribute="fvd-mbg__image-img"
      src="https://cdn.skyfastimg.com/images/2026/06/02/image-6a1e60a058c8af5f95b904d7.png?w=400&h=400&q=80"
      alt="30 Day Money Back Guarantee"
    />
  </div>
  <div class="fvd-mbg__text" data-attribute="fvd-mbg__text">
    <h2 style="text-align: center">
      <strong>Buy With Confidence – It's 100% risk-Free!</strong>
    </h2>
    <p style="text-align: center">
      In case you aren't satisfied, we are offering you our 30-Day money-back guarantee. Send your package back and get a full refund, no questions asked.
    </p>
  </div>
</div>
`;

export default containerFuild(html, css, {
  textColor: '#ffffff',
});
